module.exports = require("ieee754");


//////////////////
// WEBPACK FOOTER
// external "ieee754"
// module id = 384
// module chunks = 0